import React, { PropsWithChildren } from "react";

import { ServerError } from "./500/ServerError";

type ErrorBoundayState = {
  hasError: boolean;
};

type ErrorBoundaryProps = PropsWithChildren<{}> & {
  goBack?: () => void;
};

export class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundayState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    // You can also log the error to an error reporting service
    console.error("ErrorBoundary caught an error", error, errorInfo);
    this.setState({ hasError: true });
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <ServerError
          goBack={this.props.goBack}
          refresh={() => this.setState({ hasError: false })}
        />
      );
    }

    return this.props.children;
  }
}
